// API Configuration - Centralized using environment variables
// Update the REACT_APP_API_BASE_URL in .env file to change the backend URL

// Get API base URL from environment variable or use default
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:7001";
export const BASE_URL = `${API_BASE_URL}/admin`;

export const SOCKET_URL = `${API_BASE_URL}/admin-chat`;

// Export default for backward compatibility
export default {
  development: {
    baseURL: BASE_URL,
  },
  production: {
    baseURL: BASE_URL,
  },
};
